// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4609":"33c396db","9410":"8016d3af"}[chunkId] + ".chunk.css";
};